const TeamStatus = {
	ENABLE: 0,
	DISABLE: 1,
};

export default TeamStatus;
